/* SUPRAFEEL · Buscador (snippets/sfw-search.liquid).
   Open: nav magnifier [data-sfw-search-open], ⌘K / Ctrl+K, or "/" outside a field. Close: Esc, scrim, ×.
   Matching is local over the product index: accent/case-insensitive, one-typo tolerant for words ≥ 4 letters,
   and by need — everyday words map to the products' own claim tags (never to new claims). */
(function () {
  'use strict';
  var root = document.querySelector('[data-sfw-search]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var input = root.querySelector('[data-sfw-search-input]');
  var list = root.querySelector('[data-sfw-search-results]');
  var suggest = root.querySelector('[data-sfw-search-suggest]');
  var empty = root.querySelector('[data-sfw-search-empty]');
  var allLink = root.querySelector('[data-sfw-search-all]');
  var data = { products: [], pages: [] };
  try { data = JSON.parse(root.querySelector('[data-sfw-search-index]').textContent); } catch (e) {}

  var norm = function (s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9ñ ]+/g, ' ').replace(/\s+/g, ' ').trim(); };
  var esc = function (s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  // everyday words → words found in the products' own claim / gama / formula text
  var NEEDS = [
    [['dormir', 'sueno', 'descanso', 'descansar', 'estres', 'ansiedad', 'nervios', 'relax', 'relajar', 'noche', 'insomnio', 'calma'], ['calma', 'relajacion']],
    [['concentracion', 'concentrar', 'memoria', 'estudiar', 'estudio', 'mente', 'cerebro', 'foco'], ['foco', 'mente']],
    [['energia', 'cansancio', 'cansado', 'fatiga', 'agotamiento', 'rendimiento'], ['energia', 'vigor']],
    [['deporte', 'gimnasio', 'gym', 'musculo', 'fuerza', 'entrenar', 'entreno'], ['fuerza', 'creatina', 'movilidad']],
    [['defensas', 'resfriado', 'gripe', 'inmunidad', 'invierno', 'catarro', 'inmune'], ['defensas', 'proteccion', 'antiox', 'inmunidad']],
    [['piel', 'arrugas', 'colageno', 'belleza', 'unas', 'pelo', 'cabello', 'caida'], ['piel', 'cabello', 'capilar', 'estructura', 'belleza']],
    [['articulaciones', 'rodillas', 'articular', 'huesos', 'movilidad', 'espalda'], ['movilidad', 'huesos', 'estructura', 'comfort']],
    [['corazon', 'colesterol', 'cardio', 'cardiovascular', 'omega'], ['corazon', 'cardio']],
    [['vegano', 'vegana', 'vegetariano', 'b12'], ['veganos']],
    [['diario', 'basico', 'multivitaminico', 'vitaminas'], ['diario', 'basicos']]
  ];

  var items = (data.products || []).map(function (p) {
    return {
      p: p,
      title: norm(p.t),
      words: norm([p.t, p.c, p.g].join(' ')).split(' '),
      claim: norm(p.c),
      gama: norm(p.g),
      sub: norm(p.s)
    };
  });
  var pages = (data.pages || []).map(function (p) { return { p: p, title: norm(p.t) }; });

  // typo tolerance: Damerau–Levenshtein (a swap of two letters counts as one edit); 1 edit, 2 for words ≥ 7 letters
  var near = function (a, b) {
    var max = Math.min(a.length, b.length) >= 7 ? 2 : 1;
    if (Math.abs(a.length - b.length) > max) return false;
    var d = [], i, j;
    for (i = 0; i <= a.length; i++) { d[i] = [i]; }
    for (j = 0; j <= b.length; j++) { d[0][j] = j; }
    for (i = 1; i <= a.length; i++) {
      var rowMin = Infinity;
      for (j = 1; j <= b.length; j++) {
        var cost = a[i - 1] === b[j - 1] ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        if (d[i][j] < rowMin) rowMin = d[i][j];
      }
      if (rowMin > max) return false;
    }
    return d[a.length][b.length] <= max;
  };

  function score(it, q, tokens, needs) {
    var s = 0;
    if (it.title === q) s += 40;
    if (it.title.indexOf(q) === 0) s += 24;
    else if (it.title.indexOf(q) >= 0) s += 14;
    tokens.forEach(function (t) {
      if (it.claim.indexOf(t) >= 0) s += 9;
      if (it.gama.indexOf(t) >= 0) s += 7;
      if (it.sub.indexOf(t) >= 0) s += 4;
      if (t.length >= 4 && it.words.some(function (w) { return w.length >= 3 && (w.indexOf(t) === 0 || near(w, t)); })) s += 6;
    });
    needs.forEach(function (n) { if ((it.claim + ' ' + it.title).indexOf(n) >= 0) s += 8; });
    return s;
  }

  var mark = function (text, q) {
    var n = norm(text), at = q ? n.indexOf(q) : -1;
    if (at < 0 || n.length !== text.length) return esc(text);
    return esc(text.slice(0, at)) + '<mark>' + esc(text.slice(at, at + q.length)) + '</mark>' + esc(text.slice(at + q.length));
  };

  var active = -1;
  function render() {
    var raw = input.value;
    var q = norm(raw);
    allLink.href = allLink.getAttribute('href').split('?')[0] + (q ? '?q=' + encodeURIComponent(raw.trim()) : '');
    suggest.hidden = !!q;
    if (!q) { list.innerHTML = ''; empty.hidden = true; active = -1; return; }
    var tokens = q.split(' ').filter(function (t) { return t.length > 1; });
    var needs = [];
    NEEDS.forEach(function (row) {
      if (tokens.some(function (t) { return row[0].some(function (w) { return w.indexOf(t) === 0 || (t.length >= 4 && near(w, t)); }); })) needs = needs.concat(row[1]);
    });
    var found = items.map(function (it) { return { it: it, s: score(it, q, tokens, needs) }; })
      .filter(function (r) { return r.s > 0; })
      .sort(function (a, b) { return b.s - a.s; })
      .slice(0, 8);
    var pg = pages.filter(function (x) { return x.title.indexOf(q) >= 0 || tokens.some(function (t) { return t.length >= 3 && x.title.indexOf(t) >= 0; }); }).slice(0, 3);
    var html = '';
    if (found.length) {
      html += '<p class="sfw-search__label">' + (needs.length && !found.some(function (r) { return r.it.title.indexOf(q) >= 0; }) ? 'Para lo que buscas' : 'Productos') + '</p>';
      html += '<div class="sfw-search__grid">' + found.map(function (r) {
        var p = r.it.p;
        return '<a class="sfw-search__row" role="option" href="' + esc(p.u) + '">' +
          '<span class="sfw-search__thumb">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="360" height="360">' : '') + '</span>' +
          '<span class="sfw-search__text"><span class="sfw-search__title">' + mark(p.t, q) + '</span>' +
          '<span class="sfw-search__meta">' + esc([p.g, p.f].filter(Boolean).join(' · ')) + '</span></span>' +
          (p.c ? '<span class="sfw-search__claim" style="--jar:' + esc(p.j || '#f4f4f5') + ';--jar-ink:' + esc(p.k || '#18181b') + '">' + esc(p.c) + '</span>' : '') +
          '</a>';
      }).join('') + '</div>';
    }
    if (pg.length) {
      html += '<p class="sfw-search__label">Páginas</p>' + pg.map(function (x) {
        return '<a class="sfw-search__row sfw-search__row--page" role="option" href="' + esc(x.p.u) + '"><span class="sfw-search__title">' + mark(x.p.t, q) + '</span><span class="sfw-search__go" aria-hidden="true">↗</span></a>';
      }).join('');
    }
    list.innerHTML = html;
    empty.hidden = !!html;
    if (!html) empty.textContent = 'Nada coincide con «' + raw.trim() + '». Prueba con otra palabra o pulsa Intro para buscar en toda la tienda.';
    setActive(html ? 0 : -1);
  }

  function rows() { return [].slice.call(list.querySelectorAll('.sfw-search__row')); }
  function setActive(i) {
    var r = rows();
    active = r.length ? (i + r.length) % r.length : -1;
    r.forEach(function (el, k) { el.classList.toggle('is-active', k === active); el.setAttribute('aria-selected', k === active); });
    if (active >= 0) r[active].scrollIntoView({ block: 'nearest' });
  }

  var lastFocus = null;
  function open(q) {
    if (!root.hidden) return;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('sfw-search-open');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    if (typeof q === 'string') input.value = q;
    render();
    setTimeout(function () { input.focus(); input.select(); }, 30);
  }
  function close() {
    if (root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('sfw-search-open');
    setTimeout(function () { root.hidden = true; }, 180);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  input.addEventListener('input', render);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
    else if (e.key === 'Enter') {
      e.preventDefault();
      var r = rows()[active];
      if (r) location.href = r.href;
      else if (input.value.trim()) location.href = allLink.href;
    }
  });
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-sfw-search-close]')) { close(); return; }
    // a click on any empty area (outside the field, links, buttons and result cards) closes the panel too
    if (!e.target.closest('.sfw-search__field, a, button, input, label')) { close(); return; }
    var chip = e.target.closest('.sfw-search__chip[data-q]');
    if (chip) { input.value = chip.dataset.q; render(); input.focus(); }
  });
  list.addEventListener('mousemove', function (e) {
    var r = e.target.closest('.sfw-search__row');
    if (r) { var i = rows().indexOf(r); if (i !== active) setActive(i); }
  });
  document.addEventListener('keydown', function (e) {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); root.hidden ? open() : close(); return; }
    if (e.key === 'Escape' && !root.hidden) { close(); return; }
    if (e.key === '/' && root.hidden && !e.target.closest('input, textarea, select, [contenteditable]')) { e.preventDefault(); open(); }
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sfw-search-open]');
    if (t) { e.preventDefault(); open(); }
  });
})();
